var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoConnection = function SvgNoConnection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 74 90",
    enableBackground: "new 0 0 74 90",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fill",
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.161 90h69.677c.801 0 1.452-.65 1.452-1.452V30.484c0-.096-.009-.19-.028-.282v-.001a1.415 1.415 0 0 0-.126-.353l-.043-.082a1.42 1.42 0 0 0-.228-.308L43.833.426a1.48 1.48 0 0 0-.308-.228l-.082-.044A1.442 1.442 0 0 0 42.806 0H2.161C1.36 0 .71.65.71 1.452v87.096C.71 89.35 1.36 90 2.161 90zm66.173-60.968H44.258V4.956l24.076 24.076zM3.613 2.903h37.742v27.581c0 .802.65 1.452 1.452 1.452h27.581v55.161H3.613V2.903z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.229 40.587h-.232c-4.727 0-9.028 1.893-12.182 4.964l-.01.005-.005.006c-3.202 3.123-5.22 7.463-5.283 12.278-.125 9.64 7.616 17.585 17.254 17.712h.231c4.717 0 9.011-1.887 12.165-4.948l.025-.017.011-.016c3.2-3.124 5.217-7.461 5.28-12.274.125-9.638-7.616-17.584-17.254-17.71zM37 72.374h-.188c-7.886-.105-14.219-6.604-14.117-14.492a14.221 14.221 0 0 1 3.252-8.876l19.82 20.345A14.221 14.221 0 0 1 37 72.374zm11.047-5.236l-19.82-20.346a14.22 14.22 0 0 1 8.769-3.026l.19.001c7.886.104 14.219 6.604 14.117 14.491a14.233 14.233 0 0 1-3.256 8.88z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoConnection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-connection.c18ad63a.svg";
export { ForwardRef as ReactComponent };